export default __webpack_public_path__ + "static/media/grow_more.9fc065d7.png";